<script src="../../../common/i18n/sensory/sensoryTemplate.js"></script>
<template>
  <div class="CQSEvaluation">
    <el-form :model="tableHeadData" ref="tableForm">
      <el-table class="table" border :data="templateList" ref="scoreTable" max-height="550" :span-method="spanMethod" :row-class-name="rowClassNameFun" :cell-class-name="cellClassNameFun">
        <el-table-column :label="$t('sensory.template.detailName')" fixed="left" prop="title" min-width="160" align="center"></el-table-column>
        <el-table-column :label="$t('sensory.template.criterion')" class-name="template-detail" min-width="600px">
          <template slot-scope="scope" style="padding: 0">
            <div v-if="scope.row.detailType == 'TITLE'">{{scope.row.detail}}</div>
            <div v-else-if="scope.row.detailType == 'SCORE'">{{scope.row.detail}}</div>
            <div v-else>
              <div v-if="scope.row.isComments == 'Y'">{{scope.row.detail}}</div>
              <div v-if="scope.row.isComments != 'Y'">
                <div class="template-detail-cell row1" v-for="i in 9" :key="'row1'+i">
                  {{scope.row.detail.split('`')[i-1]==''?" 　":scope.row.detail.split('`')[i-1]}}
                </div>
                <div class="template-detail-cell row2" v-for="i in 9" :key="'row2'+i">
                  {{(scope.row.start > i||scope.row.end <i)?" ":i}}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="(plant,plantIndex) in tableHeadData" :key="plant.tmPlantId" header-align="center">
          <template slot="header">
            <div style="width: 100%" class="el-input" :class="disabled?'is-disabled':''">
              <el-tag type="info">{{tableHeadData[plantIndex].plantName}}</el-tag>
            </div>
          </template>
          <el-table-column v-for="(batch,batchIndex) of plant.batches" :key="batch.ttSensoryClbPlantBatchId" header-align="center" align="center" :min-width="250">
            <template slot="header">
              <el-tag type="info">{{$t('sensory.report.batchNo')}}:{{batch.batchNo}}</el-tag>
            </template>
            <template slot-scope="scope">
              <el-form-item style="display: inline-block" :rules="scoreRules.score2" :prop="`[${plantIndex}].batches[${batchIndex}].scores[${scope.row.ttTemplateDetailId}].score`" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments == 'Y'">
                <el-input type="textarea" :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].scores[scope.row.ttTemplateDetailId].score" :placeholder='scoresPlaceholder(disabled)'></el-input>
              </el-form-item>
              <!-- <el-input :disabled="disabled" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments == 'Y'" v-model="batch.scores[scope.row.ttTemplateDetailId].score"></el-input> -->
              <el-form-item style="width:120px; text-align:center;display: inline-block" autocomplete="off" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" :prop="`[${plantIndex}].batches[${batchIndex}].scores[${scope.row.ttTemplateDetailId}].score`" :rules="scoreRules.score">
                <el-input style="width: 50px;" class="score" :max="scope.row.end" :min="scope.row.start" :disabled="disabled" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" v-model="tableHeadData[plantIndex].batches[batchIndex].scores[scope.row.ttTemplateDetailId].score"></el-input>
              </el-form-item>
              <span v-if="scope.row.detailType == 'SCORE'">{{countScore(scope.row.scoreField,batch)}}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import commonFun from "@/utils/commonFun";
import { Message } from "element-ui";
import FileUpload from "@/components/common/fileUpload";
import icSelect from "@/components/common/icSelect";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import template from "@/api/sensory/template";

export default {
  name: "CQSEvaluation",
  components: { PickupPlant, FileUpload, icSelect },
  props: {
    plantBatchCqsList: {
      type: Object,
      default: [],
    },
    fiveBitCode: {
      type: String,
      default: "",
    },
    ttSensoryCalibrationId: {
      type: Number,
      default: {}
    },
    templateList: {
      type: Object,
      default: []
    },
    files: {
      type: Object,
      default: []
    },
    action: {
      type: String,
      default: null
    }
  },
  created() {
    this.initTableHeadData();
  },
  data() {
    var validatorScore2 = (rule, value, callback) => {
      if (value && value.indexOf("；") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(";") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(".") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value && value.indexOf("。") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value) {
        var arr = value.split(/[(|（].*?[）|)]/);
        arr.some(function (value, index) {
          if (value.indexOf(" ") != -1 || value.indexOf("　") != -1) {
            return callback(new Error("内容中不能输入空格"));
          }
        })

      }
      callback();
    };
    return {
      scoreRules: {
        score: [{ validator: this.scoreRange, trigger: ["blur"] }],
        score2: [{ type: 'number', validator: validatorScore2, trigger: ["change", "blur"] }]
      },
      tableHeadData: [],
      appearanceIndex: null,
      textureIndex: null,
      flavorIndex: null,
    }
  },
  computed: {
    disabled() {
      return this.action != 'CQS_EDIT';
    },
    countScore() {
      let that = this;
      return (scoreField, batch) => {
        let detailType = null;
        switch (scoreField) {
          case 'AppearanceScore':
            detailType = "APPEARANCE";
            break;
          case 'TextureScore':
            detailType = "TEXTURE";
            break;
          case 'FlavorScore':
            detailType = "FLAVOR";
            break;
          case 'QualityScore':
            detailType = "ALL";
            break;
        }
        let scores = that.templateList.filter(templatDetail => {
          return templatDetail.isComments != 'Y';
        }).filter(templatDetail => {
          if (detailType == "ALL") {
            return templatDetail.detailType == "APPEARANCE" || templatDetail.detailType == "TEXTURE" || templatDetail.detailType == "FLAVOR";
          } else {
            return templatDetail.detailType == detailType;
          }
        }).map(templatDetail => {
          return batch.scores[templatDetail.ttTemplateDetailId];
        });
        let count19 = scores.filter(value => value.score == 1 || value.score == 9).length;
        let count28 = scores.filter(value => value.score == 2 || value.score == 8).length;
        let count37 = scores.filter(value => value.score == 3 || value.score == 7).length;
        let count46 = scores.filter(value => value.score == 4 || value.score == 6).length;
        let count5 = scores.filter(value => value.score == 5).length;
        let score = null;
        if (count19 > 0) {
          score = 0;
        } else if (count28 > 0) {
          score = 25;
        } else if (count37 > 0) {
          score = 60 + (count5 > 0 ? (count5 / (scores.length - 1) * 20) : 0) + (count46 > 0 ? (count46 / (scores.length - 1) * 10) : 0);
        } else if (count46 > 0) {
          score = 85 + (count5 > 0 ? (count5 / (scores.length - 1) * 10) : 0);
        } else if (count5 > 0) {
          score = 100;
        }
        if (null != score) {
          return score.toFixed(1) + "%";
        }
      };
    },
    plantNames() {
      if (commonFun.isNotEmpty(this.tableHeadData)) {
        return this.tableHeadData.map(plant => plant.plantName).join(";");
      } else {
        return "";
      }
    }
  },
  methods: {
    scoresPlaceholder(val) {
      return val ? "" : "多值请用逗号分隔      例如:1(内容),2(内容)"
    },
    scoreRange(rule, value, callback) {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("common.canNotBeEmpty")));
      }
      let reg = /\[(\d)+\]/g;
      let templateDetailIndex = null;
      let res = null;
      while (res = reg.exec(rule.field)) {
        templateDetailIndex = res[0].substr(1, res[0].length - 2);
      }
      let templateDetail = this.templateList.filter(templateDetail => templateDetail.ttTemplateDetailId == templateDetailIndex)[0];
      let start = templateDetail.start;
      let end = templateDetail.end;
      if (Number.isNaN(value - 0) || value < start || value > end) {
        return callback(new Error(this.$t("sensory.report.scoreRangeErr", { start: start, end: end })));
      } else {
        return callback();
      }
    },
    validate() {
      let that = this;
      let then = that.$nextTick().then(() => {
        return that.$refs.tableForm.validate();
      });
      return then.then();
    },
    initTableHeadData() {
      let tableHeadData = [];
      this.tableHeadData = [];
      if (commonFun.isEmpty(this.plantBatchCqsList)) {
        return;
      }
      this.plantBatchCqsList.forEach(userInfo => {
        let plant = null;
        let batch = null;
        if (tableHeadData.filter(plant => plant.calibrationPlantId == userInfo.calibrationPlantId).length > 0) {
          plant = tableHeadData.filter(plant => plant.calibrationPlantId == userInfo.calibrationPlantId)[0];
        } else {
          plant = {
            calibrationPlantId: userInfo.calibrationPlantId,
            plantName: userInfo.plantName,
            tmPlantId: userInfo.tmPlantId,
            batches: []
          }
          tableHeadData.push(plant);
        }

        batch = {
          ttSensoryClbPlantBatchId: userInfo.ttSensoryClbPlantBatchId,
          ttSensoryClbDetailId: userInfo.ttSensoryClbDetailId,
          batchNo: userInfo.batchNo,
          scores: {}
        }
        if (commonFun.isNotEmpty(userInfo.clbDetailList)) {
          userInfo.clbDetailList.forEach(clbDeatil => {
            clbDeatil.score = commonFun.isEmpty(clbDeatil.score) ? undefined : clbDeatil.score;
            batch.scores[clbDeatil.templateDetailId] = clbDeatil;
          });
        } else {
          this.templateList.forEach(template => {
            if (commonFun.isNotEmpty(template.ttTemplateDetailId)) {
              let scoreInfo = {
                templateDetailId: template.ttTemplateDetailId,
                score: undefined
              }
              batch.scores[template.ttTemplateDetailId] = scoreInfo;
            }
          })
        }
        plant.batches.push(batch);
      });
      this.templateList.forEach(template => {
        if (template.detailType != 'TITLE' && template.detailType != 'SCORE') {
          tableHeadData.forEach(plant => {
            plant.batches.forEach(batch => {
              if (!batch.scores[template.ttTemplateDetailId]) {
                batch.scores[template.ttTemplateDetailId] = {
                  templateDetailId: template.ttTemplateDetailId,
                  score: null
                };
              }
            })
          })
        }
      });
      this.tableHeadData = tableHeadData;
      let that = this;
      that.$nextTick(() => {
        that.$refs["scoreTable"].doLayout();
      })
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      let userSize = 0;
      if (commonFun.isNotEmpty(this.tableHeadData)) {
        this.tableHeadData.forEach(plantData => {
          userSize += plantData.batches.length;
        });
        if (row.detailType == 'TITLE' && columnIndex == 1) {
          return [1, 1 + userSize]
        }
      }
      // this.$refs["scoreTable"].doLayout();
    },
    cellClassNameFun({ row, column, rowIndex, columnIndex }) {
      if (row.detailType == 'TITLE') {
        if (columnIndex == 0) {
          return "title";
        } else if (columnIndex == 1) {
          return "title-desc";
        }
      } else if (row.isComments == 'Y') {
        return "detail-comments"
      }
    },
    rowClassNameFun({ row, rowIndex }) {
      if (row.detailType == 'TITLE') {
        return "title";
      }
    },
  },
  watch: {
    templateList(newValue, oldValue) {
      this.$refs["scoreTable"].doLayout();
    },
    fiveBitCode(newVal, oldValue) {
      if (newVal != oldValue) {
        if (commonFun.isNotEmpty(this.tableHeadData)) {
          this.tableHeadData.forEach(plant => {
            plant.tmPlantId = null;
            plant.plantName = null;
          });
        } else {
          this.addPlant();
        }
      }
    },
    plantBatchCqsList(newVal) {
      this.initTableHeadData();
    },
    plantNames(newVal) {
      this.$emit("change-plants", newVal);
    }
  },
}
</script>
<style lang="scss">
.CQSEvaluation {
  .template-detail {
    padding: 0 !important;
  }

  // .el-table .cell {
  //   padding: 0 !important;
  // }

  .el-table {
    td:not(.template-detail),
    td.detail-comments,
    td.title,
    td.title-desc {
      .cell {
        line-height: 40px;
      }
    }
  }

  .template-detail-cell {
    width: 11.11111%;
    display: inline-block;
    text-align: center !important;
  }

  /*.template-detail-cell.row1:not(:first-child){border-left:1px solid #EBEEF5; }*/
  .template-detail-cell.row2 {
    border-top: 1px solid #ebeef5;
  }

  .template-detail-cell.row2:not(:first-child) {
    border-left: 1px solid #ebeef5;
  }

  tr.title td {
    font-weight: bold;
    font-style: oblique;
  }

  .plant-select {
    width: calc(100% - 30px);
    vertical-align: middle;
  }

  .el-table--small td,
  .el-table--small th {
    padding: 0 !important;
  }

  .score input {
    text-align: center;
  }

  .el-form-item__error {
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
  }
}
</style>
